module.exports = __webpack_public_path__ + "img/up-success.96d552c6.png";